// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"2589":"d6fdf0fb","5288":"9bf67bc7","7116":"07626bd9","9164":"66cbe70d"}[chunkId] + ".css";
};